import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import './ClientSlider.css';
import { Pagination, Navigation } from 'swiper/modules';
import CardQuote from '../../assets/images/quote.png';
// import CardProfile from '../../assets/images/card__profile.png';
// import CardProfile2 from '../../assets/images/card__profile2.png';
import HernProfile from '../../assets/images/hern.jpeg';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const ClientSlider = () => {
  const testimonials = [
    {
      text: "SIMO did a great job on our Ruby on Rails project. Clear communication, on-time delivery, and strong skills",
      name: "Juan González",
      title: "COO Patrimore",
      image: HernProfile
    },
    {
      text: "Working with SIMO was a game-changer for our startup. They delivered our MVP in record time. Will hire again.",
      name: "Hernán Azocar",
      title: "CEO GourmetJobs",
      image: HernProfile
    },
    {
      text: "Super agency, does not need supervision and is able to suggest improvements and ideas. More than a tehcnical partner",
      name: "Nipun Sud",
      title: "CEO/CTO Purnam AI",
      image: HernProfile
    },
    {
      text: "SIMO helped our start-up in various full stack development tasks In a very good way. Will hire again for sure.",
      name: "Oliver Roper",
      title: "CEO Rexsell",
      image: HernProfile
    },
    {
      text: "Clean, scalable, and high-quality solutions. Super aligned with business goals in mind make their work consistently reliable.",
      name: "Arnau Branch",
      title: "Founder Stupendastic",
      image: HernProfile
    },
    {
      text: "SIMO did excellent work at different development tasks on our platform. Communication was always direct and honest",
      name: "Pascal Schreiber",
      title: "CEO Regional Hero",
      image: HernProfile
    },
    {
      text: "Working with SIMO has been fantastic. They combine technical excellence with proactive problem-solving.",
      name: "Kelly Quijano",
      title: "CEO Smartsy",
      image: HernProfile
    },
    {
      text: "SIMO consistently exceeds expectations. Their agile development makes them a great partner for ai start-ups.",
      name: "Jake Wolski",
      title: "CEO Moneybot AI",
      image: HernProfile
    },    
  ];

  return (
    <div className="client__slider">
      <>
        <Swiper
          pagination={{
            el: '.custom-pagination',
            clickable: true,
          }}
          navigation={{
            prevEl: '.custom-prev',
            nextEl: '.custom-next',
          }}
          modules={[Navigation, Pagination]}
          slidesPerView={2}
          spaceBetween={32}
          className="mySwiper"
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 1.5,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 32,
            },
          }}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="cards__slider">
                <div className="cards__slide">
                  <img src={CardQuote} alt="" className="quote__img" />
                  <p className="cards__slider__desc">
                    "{testimonial.text}"
                  </p>
                  <div className="card__slide__profile">
                    {/* <img src={testimonial.image} alt="" className="user__profile" /> */}
                    <div className="card__slider__profile__details">
                      <h5>{testimonial.name}</h5>
                      <p>{testimonial.title}</p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="client__slider__arrows">
          <div className="swiper-button-prev custom-prev">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.57 5.93005L3.5 12.0001L9.57 18.0701"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.5 12H3.67004"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="swiper-button-next custom-next">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.4301 5.93005L20.5001 12.0001L14.4301 18.0701"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.5 12H20.33"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="pagination__swiper__slider">
            <div className="swiper-pagination custom-pagination"></div>
          </div>
        </div>
      </>
    </div>
  );
};

export default ClientSlider;
